import {LiveReducer, ReducerFromState} from "../../../@types/reducers";
import {EventsStoredObjects} from "../../../@types/response";

export const getEvents = (state: ReducerFromState<LiveReducer>): EventsStoredObjects => state.live.events;
